const initialState = {
  items: [],
  cards: [],
  loading: false,
  error: null,
  activeScope: null,
  contactTypes: [
    {
      id: "child",
    },
    {
      id: "spouse",
    },
    {
      id: "life-partner",
    },
    {
      id: "other",
    },
  ],
};

const contactReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CONTACTS_RESET":
      return { ...initialState };
    case "FETCH_CONTACTS_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
        activeScope: action.meta.scope,
      };
    case "FETCH_CONTACTS_SUCCESS":
      if (state.activeScope !== action.meta.scope) {
        return state;
      }
      return { ...state, loading: false, items: action.payload };
    case "FETCH_CONTACTS_FAILURE":
      if (state.activeScope !== action.meta.scope) {
        return state;
      }
      return { ...state, loading: false, items: [], error: action.payload };
    case "PREPARE_CONTACTS_CARDS":
      return { ...state, cards: action.payload };
    default:
      return state;
  }
};
export default contactReducer;
